/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-09 15:27:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import { useCallback, useEffect } from 'react';
import shallow from 'zustand/shallow';
import { billApi } from '@api';
import { useBillAddressState } from '@root/state';
import { useNavigate } from 'react-router-dom';
import { IState } from '@root/state/billAddress';

interface IValue extends IState {
  isBillAddress: boolean;
  onAddBill: () => void;
  getBillAddress: () => void;
}

const useBillAddressAllState = (): IValue => {
  const navigate = useNavigate();
  const {
    data,
    loaded,
    modifyData,
    loadFailed,
    setLoadFailed,
    setModifyData,
    setData,
    setLoaded,
    resetInitData,
    resetModifyData,
  } = useBillAddressState(
    (state) => ({
      data: state.data,
      loaded: state.loaded,
      modifyData: state.modifyData,
      loadFailed: state.loadFailed,
      setLoadFailed: state.setLoadFailed,
      setLoaded: state.setLoaded,
      setData: state.setData,
      setModifyData: state.setModifyData,
      resetInitData: state.resetInitData,
      resetModifyData: state.resetModifyData,
    }),
    shallow,
  );

  const getBillAddress = useCallback(() => {
    billApi
      .getBillAddress()
      .then((data: any) => {
        if (data) {
          setData(data);
        }
        setLoaded(true);
      })
      .catch(() => {
        setLoadFailed(true);
      });
  }, [setData, setLoadFailed, setLoaded]);

  const onAddBill = useCallback(() => {
    navigate('/billAddress?back=1');
  }, [navigate]);

  useEffect(() => {
    if (!loaded) {
      getBillAddress();
    }
  }, [getBillAddress, loaded]);

  return {
    isBillAddress: !!data.id,
    data,
    loaded,
    modifyData,
    loadFailed,
    setLoadFailed,
    setModifyData,
    setData,
    setLoaded,
    onAddBill,
    resetInitData,
    getBillAddress,
    resetModifyData,
  };
};

export default useBillAddressAllState;
